import axios from 'axios';

export const INVALID_CAPTCHA_TOKEN_ERROR_CODE = 'iam/invalid_captcha_token';

type ApiErrorBody = { error?: { code?: string } };

export const isInvalidCaptchaTokenError = (error: unknown): boolean => {
  const axiosError = axios.isAxiosError(error)
    ? error
    : error instanceof Error && axios.isAxiosError(error.cause)
    ? error.cause
    : undefined;

  if (axiosError?.response?.status !== 400) {
    return false;
  }

  return (axiosError.response.data as ApiErrorBody | undefined)?.error?.code === INVALID_CAPTCHA_TOKEN_ERROR_CODE;
};
